import {
  whiteColor,
  blackColor,
  dangerColor,
  successColor,
  lightGrayColor,
  defaultFont,
  helpText,
} from '../../../assets/styles/jss/main';

export const styles = {
  root: {
    border: `1px solid ${lightGrayColor}`,
    background: '#f6f6f9',
    borderRadius: '5px',
    '& fieldset': {
      display: 'none',
    },
  },
  rootWithMultiLine: {
    border: '2px solid #ececee',
    '& div:first-child': { minHeight: '30px' },
    '& textarea:not([readOnly])': {
      border: 'none',
      width: 'calc(100% - 10px)',
      height: '100%',
      margin: '-5px 0 0 -5px',
    },
  },
  input: {
    position: 'relative',
    padding: '2px 25px 2px 12px',
    fontWeight: '400',
    height: '36px',
    fontSize: '16px',
    lineHeight: '1.428571429',
    color: blackColor,
    textOverflow: 'ellipsis',
    border: '2px solid #ececee',
    '&[rows]': { height: 'auto' },
  },
  inputError: { borderColor: `${dangerColor} !important` },
  inputSuccess: { borderColor: `${successColor} !important` },
  disabled: {
    '&:before': {
      background: 'transparent !important',
      backgroundSize: '3px 1px !important',
      backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0.23) 33%, transparent 0%) !important',
      backgroundRepeat: 'repeat-x !important',
      backgroundPosition: 'left top !important',
    },
  },
  labelRoot: {
    ...defaultFont,
    position: 'relative !important',
    color: `${blackColor}!important`,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '22px',
    transform: 'scale(1)',
    '& + .MuiInputBase-root': {
      marginTop: '10px',
    },
  },
  labelRootError: { color: `${dangerColor}!important` },
  labelRootSuccess: { color: `${successColor}!important` },
  feedback: {
    position: 'absolute',
    bottom: '20px',
    right: '5px',
    zIndex: '2',
    display: 'block',
    width: '24px',
    height: '24px',
    textAlign: 'center',
    pointerEvents: 'none',
  },
  feedbackNoLabel: { top: '10px' },
  feedbackWithHelp: { bottom: 0, top: 10 },
  passwordEyeWrapper: { margin: 0 },
  passwordEye: {
    position: 'absolute',
    bottom: 10,
    right: 5,
    zIndex: '2',
    display: 'block',
    width: '24px',
    height: '24px',
    textAlign: 'center',
    cursor: 'pointer',
    fill: '#cecdd6',
  },
  inputRTL: { textAlign: 'right' },
  inputWithAdornment: { paddingTop: '21px' },
  formControl: { paddingBottom: '10px', position: 'relative' },
  labelWithAdornment: { top: '3px' },
  feedbackAdornment: { right: '22px' },
  helpText: { ...helpText },
  transparent: { background: 'transparent', border: 'none' },
  white: { background: whiteColor, border: 'none' },
  clickable: { cursor: 'pointer' },
};

export const decimalStyles = {
  1: { maxWidth: 66 },
  2: { maxWidth: 75 },
  3: { maxWidth: 84 },
  4: { maxWidth: 93 },
  5: { maxWidth: 102 },
  6: { maxWidth: 112 },
  7: { maxWidth: 122 },
  8: { maxWidth: 132 },
  9: { maxWidth: 142 },
  10: { maxWidth: 147 },
};

export const feedbackDecimalStyles = {
  1: { top: 'unset', bottom: 20, left: 40 },
  2: { top: 'unset', bottom: 20, left: 45 },
  3: { top: 'unset', bottom: 20, left: 55 },
  4: { top: 'unset', bottom: 20, left: 65 },
  5: { top: 'unset', bottom: 20, left: 75 },
  6: { top: 'unset', bottom: 20, left: 85 },
  7: { top: 'unset', bottom: 20, left: 95 },
  8: { top: 'unset', bottom: 20, left: 105 },
  9: { top: 'unset', bottom: 20, left: 115 },
  10: { top: 'unset', bottom: 20, left: 120 },
};
